import React, { useEffect, useState, useRef, useCallback } from 'react'
import Box, { Item as BoxItem } from 'devextreme-react/box'
import CustomStore from 'devextreme/data/custom_store'
import DataGrid, {
	Column,
	Selection,
	Editing,
	Paging,
	FilterRow,
	Toolbar,
	Item as ToolbarItem,
} from 'devextreme-react/data-grid'
import Button from 'devextreme-react/button'
import { Switch } from 'devextreme-react/switch'
import SelectBox from 'devextreme-react/select-box'
import { confirmDialog } from '../../components'
import TabPanel, { Item as TabItem } from 'devextreme-react/tab-panel'
import { loadData, insertData, editData, deleteRolesData } from '../../utils/model-data'
import notify from '../../utils/notify'
import axios from 'axios'

export default function Model() {
	const [views, setViews] = useState<any>([])
	const [processes, setProcesses] = useState<any>([])
	const [reports, setReports] = useState<any>([])

	const [groups, setGroups] = useState<any>([])
	const [reportGroups, setReportGroups] = useState<any>([])
	const [processGroups, setProcessGroups] = useState<any>([])
	const [viewGroups, setViewGroups] = useState<any>([])

	const [userStore, setUserStore] = useState()
	const [groupStore, setGroupStore] = useState()
	const [viewsStore, setViewsStore] = useState()
	const [processesStore, setProcessesStore] = useState()
	const [reportsStore, setReportsStore] = useState()

	const [height, setHeight] = useState(0)

	const [user, setUser] = useState({})
	const [group, setGroup] = useState({})
	const [view, setView] = useState({})
	const [process, setProcess] = useState({})
	const [report, setReport] = useState({})

	// Field permissions state
	const [fieldPermissions, setFieldPermissions] = useState<any>([])
	const [availableModels, setAvailableModels] = useState<any>([])
	const [selectedModel, setSelectedModel] = useState<string>('')
	const [modelFields, setModelFields] = useState<any>([])
	const [fieldPermError, setFieldPermError] = useState<string | null>(null)

	// View permissions state
	const [viewPermissions, setViewPermissions] = useState<any>([])
	const [availableViews, setAvailableViews] = useState<any>([])
	const [selectedView, setSelectedView] = useState<string>('')
	const [viewPermError, setViewPermError] = useState<string | null>(null)

	const usersGridRef = useRef<DataGrid | null>(null)
	const groupsGridRef = useRef<DataGrid | null>(null)
	const viewsGridRef = useRef<DataGrid | null>(null)
	const processesGridRef = useRef<DataGrid | null>(null)
	const reportsGridRef = useRef<DataGrid | null>(null)

	useEffect(() => {
		document.title = 'Fiber :: Roles'
	}, [])

	const selectUser = useCallback((e: any) => {
		if (e.currentSelectedRowKeys[0]) {
			e.component.byKey(e.currentSelectedRowKeys[0]).done((item: any) => {
				item.row = e.currentSelectedRowKeys[0]
				setUser(item)
			})
		} else {
			setUser({})
		}
	}, [])

	const selectGroup = useCallback((e: any) => {
		if (e.currentSelectedRowKeys[0]) {
			e.component.byKey(e.currentSelectedRowKeys[0]).done((item: any) => {
				item.row = e.currentSelectedRowKeys[0]
				setGroup(item)
			})
		} else {
			setGroup({})
		}
	}, [])

	const selectView = useCallback((e: any) => {
		if (e.currentSelectedRowKeys[0]) {
			e.component.byKey(e.currentSelectedRowKeys[0]).done((item: any) => {
				item.row = e.currentSelectedRowKeys[0]
				setView(item)
			})
		} else {
			setView({})
		}
	}, [])

	const selectProcess = useCallback((e: any) => {
		if (e.currentSelectedRowKeys[0]) {
			e.component.byKey(e.currentSelectedRowKeys[0]).done((item: any) => {
				item.row = e.currentSelectedRowKeys[0]
				setProcess(item)
			})
		} else {
			setProcess({})
		}
	}, [])

	const selectReport = useCallback((e: any) => {
		if (e.currentSelectedRowKeys[0]) {
			e.component.byKey(e.currentSelectedRowKeys[0]).done((item: any) => {
				item.row = e.currentSelectedRowKeys[0]
				setReport(item)
			})
		} else {
			setReport({})
		}
	}, [])

	const changedRoleGroup = (u: any, group: number, e: any) => {
		if (e.event) {
			e.event.stopPropagation()
			const { user_id, row } = u
			const cmd = e.value ? 'set' : 'unset'
			const uGroups =
				cmd === 'set'
					? setRoleGroup(u?.groups as [], group as never)
					: unsetRoleGroup(u?.groups as [], group as never)
			u.groups = uGroups
			setUser(prevUser => ({ ...(prevUser || {}), groups: uGroups }))
			const grid = usersGridRef.current?.instance
			if (grid) {
				grid.cellValue(row, 'groups', uGroups)
			}
			axios.patch(`${API_FIBER_URL}/users/${user_id}/${cmd}/${group}`)
		}
	}

	const changedRoleView = (folder: string, model: string, e: any) => {
		if (e.event) {
			e.event.stopPropagation()
			const g = group as any
			const { id, row } = g
			const cmd = e.value ? 'set' : 'unset'
			const gViews =
				cmd === 'set'
					? setRoleView(g?.views as [], folder, model)
					: unsetRoleView(g?.views as [], folder, model)
			g.views = gViews
			setGroup(prevGroup => ({ ...(prevGroup || {}), views: gViews }))
			const grid = groupsGridRef.current?.instance
			if (grid) {
				grid.cellValue(row, 'views', gViews)
			}
			axios.patch(`${API_FIBER_URL}/roles/${id}/${cmd}?folder=${folder}&model=${model}`).then(() => {
				viewsGridRef.current?.instance.refresh()
			})
		}
	}

	const changedRoleDenyModifyView = (folder: string, model: string, e: any) => {
		if (e.event) {
			e.event.stopPropagation()
			const g = group as any
			const { id, row } = g
			const cmd = e.value ? 'set' : 'unset'
			const gDViews =
				cmd === 'set'
					? setRoleView(g?.deny_modify_views as [], folder, model)
					: unsetRoleView(g?.deny_modify_views as [], folder, model)
			g.deny_modify_views = gDViews
			setGroup(prevGroup => ({ ...(prevGroup || {}), deny_modify_views: gDViews }))
			const grid = groupsGridRef.current?.instance
			if (grid) {
				grid.cellValue(row, 'deny_modify_views', gDViews)
			}
			axios
				.patch(`${API_FIBER_URL}/roles/${id}/${cmd}?folder=${folder}&model=${model}&deny_modify=true`)
				.then(() => {
					viewsGridRef.current?.instance.refresh()
				})
		}
	}

	const changedGroupsRoleView = (g: any, folder: string, model: string, e: any) => {
		if (e.event) {
			e.event.stopPropagation()
			const cmd = e.value ? 'set' : 'unset'
			const { id, views } = g
			const gViews =
				cmd === 'set' ? setRoleView(views as [], folder, model) : unsetRoleView(views as [], folder, model)
			g.views = gViews
			setViewGroups((prevViewGroups: any[]) => {
				const updatedViewGroups = prevViewGroups.map(viewGroup => {
					if (viewGroup.id === id) {
						return { ...viewGroup, views: gViews }
					}
					return viewGroup
				})
				return updatedViewGroups
			})
			axios.patch(`${API_FIBER_URL}/roles/${id}/${cmd}?folder=${folder}&model=${model}`).then(() => {
				groupsGridRef.current?.instance.refresh()
			})
		}
	}

	const changedGroupsRoleDenyModifyView = (g: any, folder: string, model: string, e: any) => {
		if (e.event) {
			e.event.stopPropagation()
			const cmd = e.value ? 'set' : 'unset'
			const { id, deny_modify_views } = g
			const gDViews =
				cmd === 'set'
					? setRoleView(deny_modify_views as [], folder, model)
					: unsetRoleView(deny_modify_views as [], folder, model)
			g.deny_modify_views = gDViews
			setViewGroups((prevViewGroups: any[]) => {
				const updatedViewGroups = prevViewGroups.map(viewGroup => {
					if (viewGroup.id === id) {
						return { ...viewGroup, deny_modify_views: gDViews }
					}
					return viewGroup
				})
				return updatedViewGroups
			})
			axios
				.patch(`${API_FIBER_URL}/roles/${id}/${cmd}?folder=${folder}&model=${model}&deny_modify=true`)
				.then(() => {
					groupsGridRef.current?.instance.refresh()
				})
		}
	}

	const changedRoleProcess = (process: string, e: any) => {
		if (e.event) {
			e.event.stopPropagation()
			const g = group as any
			const { id, row } = g
			const cmd = e.value ? 'set' : 'unset'
			const gProcesses =
				cmd === 'set'
					? setRoleProcess(g?.processes as [], process)
					: unsetRoleProcess(g?.processes as [], process)
			g.Processes = gProcesses
			setGroup(prevGroup => ({ ...(prevGroup || {}), processes: gProcesses }))
			const grid = groupsGridRef.current?.instance
			if (grid) {
				grid.cellValue(row, 'processes', gProcesses)
			}
			axios.patch(`${API_FIBER_URL}/roles/${id}/${cmd}?process=${process}`).then(() => {
				processesGridRef.current?.instance.refresh()
			})
		}
	}

	const changedGroupsRoleProcess = (g: any, process: string, e: any) => {
		if (e.event) {
			e.event.stopPropagation()
			const cmd = e.value ? 'set' : 'unset'
			const { id, processes } = g
			const gProcesses =
				cmd === 'set' ? setRoleProcess(processes as [], process) : unsetRoleProcess(processes as [], process)
			g.processes = gProcesses
			setProcessGroups((prevProcessGroups: any[]) => {
				const updatedProcessGroups = prevProcessGroups.map(processGroup => {
					if (processGroup.id === id) {
						return { ...processGroup, processes: gProcesses }
					}
					return processGroup
				})
				return updatedProcessGroups
			})
			axios.patch(`${API_FIBER_URL}/roles/${id}/${cmd}?process=${process}`).then(() => {
				groupsGridRef.current?.instance.refresh()
			})
		}
	}

	const changedRoleReport = (report: string, e: any) => {
		if (e.event) {
			e.event.stopPropagation()
			const g = group as any
			const { id, row } = g
			const cmd = e.value ? 'set' : 'unset'
			const gReports =
				cmd === 'set' ? setRoleReport(g?.reports as [], report) : unsetRoleReport(g?.reports as [], report)
			g.Reports = gReports
			setGroup(prevGroup => ({ ...(prevGroup || {}), reports: gReports }))
			const grid = groupsGridRef.current?.instance
			if (grid) {
				grid.cellValue(row, 'reports', gReports)
			}
			axios.patch(`${API_FIBER_URL}/roles/${id}/${cmd}?report=${report}`).then(() => {
				reportsGridRef.current?.instance.refresh()
			})
		}
	}

	const changedGroupsRoleReport = (g: any, report: string, e: any) => {
		if (e.event) {
			e.event.stopPropagation()
			const cmd = e.value ? 'set' : 'unset'
			const { id, reports } = g
			const gReports =
				cmd === 'set' ? setRoleReport(reports as [], report) : unsetRoleReport(reports as [], report)
			g.reports = gReports
			setReportGroups((prevReportGroups: any[]) => {
				const updatedReportGroups = prevReportGroups.map(reportGroup => {
					if (reportGroup.id === id) {
						return { ...reportGroup, reports: gReports }
					}
					return reportGroup
				})
				return updatedReportGroups
			})
			axios.patch(`${API_FIBER_URL}/roles/${id}/${cmd}?report=${report}`).then(() => {
				groupsGridRef.current?.instance.refresh()
			})
		}
	}

	const loadAvailableModels = useCallback(() => {
		axios
			.get(`${API_FIBER_URL}/users/field-permissions/models`)
			.then(response => {
				if (response.data.success) {
					setAvailableModels(response.data.data)
				}
			})
			.catch(error => {
				notify('Failed to load models', 'error')
			})
	}, [])

	const loadAvailableViews = useCallback(() => {
		axios
			.get(`${API_FIBER_URL}/users/field-permissions/models`)
			.then(response => {
				if (response.data.success) {
					const views = response.data.data.map((model: any) => ({
						key: `${model.folder}/${model.model}`,
						name: model.name,
						folder: model.folder,
						model: model.model,
						deleting: model.deleting,
						inserting: model.inserting,
					}))
					setAvailableViews(views)
				}
			})
			.catch(error => {
				notify('Failed to load views', 'error')
			})
	}, [])

	const loadModelFields = useCallback((model: string) => {
		if (!model) return

		axios
			.get(`${API_FIBER_URL}/users/field-permissions/fields/${model}`)
			.then(response => {
				if (response.data.success) {
					setModelFields(response.data.data)
				}
			})
			.catch(error => {
				notify('Failed to load fields', 'error')
			})
	}, [])

	const loadUserFieldPermissions = useCallback((userId: string) => {
		if (!userId) return

		axios
			.get(`${API_FIBER_URL}/users/${userId}/field-permissions`)
			.then(response => {
				if (response.data.success) {
					setFieldPermissions(response.data.data)
				}
			})
			.catch(error => {
				notify('Failed to load field permissions', 'error')
			})
	}, [])

	const loadUserViewPermissions = useCallback((userId: string) => {
		if (!userId) return

		axios
			.get(`${API_FIBER_URL}/users/${userId}/view-permissions`)
			.then(response => {
				if (response.data.success) {
					setViewPermissions(response.data.data)
				}
			})
			.catch(error => {
				notify('Failed to load view permissions', 'error')
			})
	}, [])

	const changedFieldPermission = (userId: string, model: string, field: string, permission: string, e: any) => {
		if (e.event) {
			e.event.stopPropagation()
			const cmd = e.value ? 'set' : 'unset'

			if (cmd === 'set') {
				setFieldPermissions((prev: any[]) => [...prev, { model, field, permission }])
			} else {
				setFieldPermissions((prev: any[]) =>
					prev.filter(p => !(p.model === model && p.field === field && p.permission === permission))
				)
			}

			if (cmd === 'set') {
				axios
					.post(`${API_FIBER_URL}/users/${userId}/field-permissions`, {
						model,
						field,
						permission,
					})
					.catch(error => {
						setFieldPermError(error?.response?.data?.message || error.message || 'Unknown error')
						setFieldPermissions((prev: any[]) =>
							prev.filter(p => !(p.model === model && p.field === field && p.permission === permission))
						)
					})
			} else {
				axios
					.delete(`${API_FIBER_URL}/users/${userId}/field-permissions`, {
						data: { model, field, permission },
					})
					.catch(error => {
						setFieldPermissions((prev: any[]) => [...prev, { model, field, permission }])
					})
			}
		}
	}

	const hasFieldPermission = useCallback((permissions: any[], model: string, field: string, permission: string) => {
		return permissions.some(p => p.model === model && p.field === field && p.permission === permission)
	}, [])

	const changedViewPermission = (userId: string, folder: string, model: string, permission: string, e: any) => {
		if (e.event) {
			e.event.stopPropagation()
			const cmd = e.value ? 'set' : 'unset'

			if (cmd === 'set') {
				setViewPermissions((prev: any[]) => [...prev, { folder, model, permission }])
			} else {
				setViewPermissions((prev: any[]) =>
					prev.filter(p => !(p.folder === folder && p.model === model && p.permission === permission))
				)
			}

			if (cmd === 'set') {
				axios
					.post(`${API_FIBER_URL}/users/${userId}/view-permissions`, {
						folder,
						model,
						permission,
					})
					.catch(error => {
						setViewPermError(error?.response?.data?.message || error.message || 'Unknown error')
						setViewPermissions((prev: any[]) =>
							prev.filter(p => !(p.folder === folder && p.model === model && p.permission === permission))
						)
					})
			} else {
				axios
					.delete(`${API_FIBER_URL}/users/${userId}/view-permissions`, {
						data: { folder, model, permission },
					})
					.catch(error => {
						setViewPermissions((prev: any[]) => [...prev, { folder, model, permission }])
					})
			}
		}
	}

	useEffect(() => {
		const handleResize = () => {
			const viewportHeight = window.innerHeight
			setHeight(viewportHeight - 320)
		}

		handleResize()
		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	useEffect(() => {
		const ds = new CustomStore({
			key: 'user_id',
			load: loadOptions => {
				return loadData(`users`, loadOptions, {})
					.then(response => response.data)
					.then(data => {
						if (data.groups) {
							setGroups(data.groups)
						}
						return {
							data: data.users,
							totalCount: -1,
						}
					})
			},
		})
		setUserStore(ds as any)
	}, [])

	useEffect(() => {
		const ds = new CustomStore({
			key: 'id',
			load: loadOptions => {
				return loadData(`roles`, loadOptions, {})
					.then(response => response.data)
					.then(data => {
						setViews(data.views)
						setProcesses(data.processes)
						setReports(data.reports)
						return {
							data: data.groups,
							totalCount: -1,
						}
					})
			},
			insert: values => {
				return insertData(`roles`, values)
			},
			update: (key, values: any) => {
				values.key = key
				return editData(`roles`, values)
			},
			remove: key => {
				return deleteRolesData(key)
			},
		})
		setGroupStore(ds as any)
	}, [])

	useEffect(() => {
		const ds = new CustomStore({
			key: 'key',
			load: loadOptions => {
				return loadData(`roles/views`, loadOptions, {})
					.then(response => response.data)
					.then(data => {
						if (data.groups) {
							setViewGroups(data.groups)
						}
						return {
							data: data.views,
							totalCount: -1,
						}
					})
			},
		})
		setViewsStore(ds as any)
	}, [])

	useEffect(() => {
		const ds = new CustomStore({
			key: 'key',
			load: loadOptions => {
				return loadData(`roles/processes`, loadOptions, {})
					.then(response => response.data)
					.then(data => {
						if (data.groups) {
							setProcessGroups(data.groups)
						}
						return {
							data: data.processes,
							totalCount: -1,
						}
					})
			},
		})
		setProcessesStore(ds as any)
	}, [])

	useEffect(() => {
		const ds = new CustomStore({
			key: 'key',
			load: loadOptions => {
				return loadData(`roles/reports`, loadOptions, {})
					.then(response => response.data)
					.then(data => {
						if (data.groups) {
							setReportGroups(data.groups)
						}
						return {
							data: data.reports,
							totalCount: -1,
						}
					})
			},
		})
		setReportsStore(ds as any)
	}, [])

	useEffect(() => {
		loadAvailableModels()
		loadAvailableViews()
	}, [loadAvailableModels, loadAvailableViews])

	useEffect(() => {
		const u = user as any
		if (u.user_id) {
			loadUserFieldPermissions(u.user_id)
			loadUserViewPermissions(u.user_id)
		}
	}, [user, loadUserFieldPermissions, loadUserViewPermissions])

	useEffect(() => {
		if (selectedModel) {
			loadModelFields(selectedModel)
		}
	}, [selectedModel, loadModelFields])

	function hasRoleGroup(groups: [], group_id: never) {
		return groups && groups.indexOf(group_id) > -1
	}

	function setRoleGroup(groups: [], group: never) {
		let newGroups = groups
		if (newGroups === null) {
			newGroups = []
		}
		if (newGroups && newGroups.indexOf(group) === -1) {
			newGroups.push(group)
		}
		return newGroups
	}

	function unsetRoleGroup(groups: [], group: never) {
		const index = groups ? groups.indexOf(group) : -1
		if (index > -1) {
			delete groups[index]
		}
		return groups
	}

	function removeUserFromGroup(user: any, group: any) {
		groupsGridRef.current?.instance.deselectAll()
		axios.patch(`${API_FIBER_URL}/users/${user.user_id}/unset/${group.id}`).then(() => {
			usersGridRef.current?.instance.refresh()
			groupsGridRef.current?.instance.refresh()
		})
	}

	function UserGroups() {
		const u = user as any
		const { name } = u
		return (
			<div className="form">
				<div className="dx-fieldset">
					<div className="dx-fieldset-header" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
						User: {name}
						<p></p>
					</div>
					{groups.map((group: any) => (
						<div className="dx-field" key={group.id}>
							<div className="dx-field-label">{group.name}</div>
							<Switch
								value={hasRoleGroup(u?.groups as [], group.id as never)}
								onValueChanged={e => changedRoleGroup(u, group.id, e)}
							></Switch>
						</div>
					))}
				</div>
			</div>
		)
	}

	function ViewGroups() {
		const v = view as any
		const { folder, model, name, show_deny } = v
		return (
			<div className="form">
				<div className="dx-fieldset">
					<div className="dx-fieldset-header" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
						View: {name}
						<p></p>
					</div>
					{viewGroups.map((g: any) => {
						const hasViewRole = hasRoleView(g?.views as [], folder, model)
						return (
							<div className="dx-field" key={g.id}>
								<div className="dx-field-label">{g.name}</div>
								<Switch
									value={hasViewRole}
									onValueChanged={e => changedGroupsRoleView(g, folder, model, e)}
								></Switch>
								{show_deny && hasViewRole && (
									<div style={{ marginLeft: '20px', display: 'flex', alignItems: 'center' }}>
										<i
											className="dx-icon dx-icon-lock"
											style={{ fontSize: '20px', color: 'grey', marginRight: '2px' }}
										></i>
										<Switch
											value={hasRoleView(g?.deny_modify_views as [], folder, model)}
											onValueChanged={e => changedGroupsRoleDenyModifyView(g, folder, model, e)}
										></Switch>
									</div>
								)}
							</div>
						)
					})}
				</div>
			</div>
		)
	}

	function ProcessGroups() {
		const p = process as any
		const { key } = p
		return (
			<div className="form">
				<div className="dx-fieldset">
					<div className="dx-fieldset-header" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
						Process: {p.name}
						<p></p>
					</div>
					{processGroups.map((g: any) => (
						<div className="dx-field" key={g.id}>
							<div className="dx-field-label">{g.name}</div>
							<Switch
								value={hasRoleProcess(g.processes as [], key)}
								onValueChanged={e => changedGroupsRoleProcess(g, key, e)}
							></Switch>
						</div>
					))}
				</div>
			</div>
		)
	}

	function ReportGroups() {
		const r = report as any
		const { key } = r
		return (
			<div className="form">
				<div className="dx-fieldset">
					<div className="dx-fieldset-header" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
						Report: {r.name}
						<p></p>
					</div>
					{reportGroups.map((g: any) => (
						<div className="dx-field" key={g.id}>
							<div className="dx-field-label">{g.name}</div>
							<Switch
								value={hasRoleReport(g.reports as [], key)}
								onValueChanged={e => changedGroupsRoleReport(g, key, e)}
							></Switch>
						</div>
					))}
				</div>
			</div>
		)
	}

	function FieldPermissions() {
		const u = user as any
		const { user_id } = u

		if (!user_id) return null

		const modelFieldPermissions = fieldPermissions.filter((p: any) => p.model === selectedModel)

		return (
			<div className="form">
				<div className="dx-fieldset">
					<div className="dx-field">
						<SelectBox
							dataSource={availableModels}
							value={selectedModel}
							onValueChanged={e => {
								setSelectedModel(e.value)
							}}
							searchEnabled={true}
							placeholder="Search models..."
							showClearButton={true}
							stylingMode="outlined"
							displayExpr="name"
							valueExpr="key"
							width="100%"
							itemRender={item => (
								<div>
									<div style={{ fontWeight: 'bold' }}>{item.name}</div>
									<div style={{ fontSize: '12px', color: '#666' }}>{item.key}</div>
								</div>
							)}
						/>
					</div>

					{fieldPermError && <div style={{ color: 'red', margin: '10px 0' }}>Error: {fieldPermError}</div>}

					{selectedModel && modelFields.length > 0 && modelFieldPermissions.length === 0 && (
						<div style={{ color: '#888', margin: '10px 0' }}>
							No field permissions exist for this user and model. Use the toggles below to add
							permissions.
						</div>
					)}

					{fieldPermissions.length > 0 && (
						<div className="dx-fieldset">
							<div
								className="dx-fieldset-header"
								style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)', marginTop: '20px' }}
							>
								Current Field Permissions
							</div>
							{fieldPermissions.map((permission: any, index: number) => (
								<div className="dx-field" key={index}>
									<div
										className="dx-field-label"
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
										}}
									>
										<span>
											{permission.model}.{permission.field}
										</span>
										<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
											<span
												style={{
													fontSize: '12px',
													padding: '2px 8px',
													borderRadius: '12px',
													backgroundColor:
														permission.permission === 'edit' ? '#4CAF50' : '#2196F3',
													color: 'white',
												}}
											>
												{permission.permission}
											</span>
											<Button
												icon="trash"
												stylingMode="text"
												onClick={() => {
													setFieldPermissions((prev: any[]) =>
														prev.filter(
															p =>
																!(
																	p.model === permission.model &&
																	p.field === permission.field &&
																	p.permission === permission.permission
																)
														)
													)
													axios
														.delete(`${API_FIBER_URL}/users/${user_id}/field-permissions`, {
															data: {
																model: permission.model,
																field: permission.field,
																permission: permission.permission,
															},
														})
														.catch(error => {
															setFieldPermissions((prev: any[]) => [...prev, permission])
														})
												}}
												style={{ color: '#f44336' }}
											/>
										</div>
									</div>
								</div>
							))}
						</div>
					)}

					{selectedModel && modelFields.length > 0 && (
						<div className="dx-fieldset">
							<div
								className="dx-fieldset-header"
								style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)', marginTop: '20px' }}
							>
								Field Permissions for {selectedModel}
							</div>
							{modelFields.map((field: any) => (
								<div className="dx-field" key={field.key}>
									<div
										className="dx-field-label"
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
										}}
									>
										<span>{field.name}</span>
									</div>
									<div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
										<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
											<span style={{ fontSize: '12px' }}>Hide:</span>
											<Switch
												value={hasFieldPermission(
													fieldPermissions,
													selectedModel,
													field.key,
													'hide'
												)}
												onValueChanged={e =>
													changedFieldPermission(user_id, selectedModel, field.key, 'hide', e)
												}
											/>
										</div>
										<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
											<span style={{ fontSize: '12px' }}>Edit:</span>
											<Switch
												value={hasFieldPermission(
													fieldPermissions,
													selectedModel,
													field.key,
													'edit'
												)}
												onValueChanged={e =>
													changedFieldPermission(user_id, selectedModel, field.key, 'edit', e)
												}
											/>
										</div>
									</div>
								</div>
							))}
						</div>
					)}
				</div>
			</div>
		)
	}

	function ViewPermissions() {
		const u = user as any
		const { user_id } = u

		if (!user_id) return null

		const viewOptions = availableViews

		const selectedViewPermission = viewPermissions.filter((p: any) => p.folder + '/' + p.model === selectedView)

		const selectedModelData = availableViews.find((view: any) => view.key === selectedView)
		const defaultDeleting = selectedModelData?.deleting ?? false
		const defaultInserting = selectedModelData?.inserting ?? false
		const defaultExporting = false

		// Get folder and model from selectedView (format: "folder/model" or "folder/subfolder/model")
		const selectedViewParts = selectedView?.split('/') || []
		const selectedModel = selectedViewParts[selectedViewParts.length - 1] // Last part is always the model
		const selectedFolder = selectedViewParts.slice(0, -1).join('/') // Everything except last part is the folder

		const explicitDeletePermission = viewPermissions.find(
			(p: any) =>
				p.folder === selectedFolder &&
				p.model === selectedModel &&
				(p.permission === 'delete_deny' || p.permission === 'delete_allow')
		)
		const explicitInsertPermission = viewPermissions.find(
			(p: any) =>
				p.folder === selectedFolder &&
				p.model === selectedModel &&
				(p.permission === 'insert_deny' || p.permission === 'insert_allow')
		)
		const explicitExportPermission = viewPermissions.find(
			(p: any) =>
				p.folder === selectedFolder &&
				p.model === selectedModel &&
				(p.permission === 'export_deny' || p.permission === 'export_allow')
		)

		const effectiveDeletePermission = explicitDeletePermission
			? explicitDeletePermission.permission === 'delete_allow'
			: defaultDeleting
		const effectiveInsertPermission = explicitInsertPermission
			? explicitInsertPermission.permission === 'insert_allow'
			: defaultInserting
		const effectiveExportPermission = explicitExportPermission
			? explicitExportPermission.permission === 'export_allow'
			: defaultExporting

		return (
			<div className="form">
				<div className="dx-fieldset">
					<div className="dx-field">
						<SelectBox
							dataSource={viewOptions}
							value={selectedView}
							onValueChanged={e => {
								setSelectedView(e.value)
							}}
							searchEnabled={true}
							placeholder="Search views..."
							showClearButton={true}
							stylingMode="outlined"
							displayExpr="name"
							valueExpr="key"
							width="100%"
							itemRender={item => (
								<div>
									<div style={{ fontWeight: 'bold' }}>{item.name}</div>
									<div style={{ fontSize: '12px', color: '#666' }}>{item.key}</div>
								</div>
							)}
						/>
					</div>

					{viewPermError && <div style={{ color: 'red', margin: '10px 0' }}>Error: {viewPermError}</div>}

					{selectedView &&
						selectedViewPermission.length === 0 &&
						!defaultDeleting &&
						!defaultInserting &&
						!defaultExporting && (
							<div style={{ color: '#888', margin: '10px 0' }}>
								No permissions exist for this user and view. Use the toggles below to add permissions.
							</div>
						)}

					{viewPermissions.length > 0 && (
						<div className="dx-fieldset">
							<div
								className="dx-fieldset-header"
								style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)', marginTop: '20px' }}
							>
								Current View Permissions
							</div>
							{viewPermissions.map((permission: any, index: number) => (
								<div className="dx-field" key={index}>
									<div
										className="dx-field-label"
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
										}}
									>
										<span>
											{permission.folder}/{permission.model}
										</span>
										<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
											<span
												style={{
													fontSize: '12px',
													padding: '2px 8px',
													borderRadius: '12px',
													backgroundColor:
														permission.permission === 'delete' ? '#f44336' : '#2196F3',
													color: 'white',
												}}
											>
												{permission.permission}
											</span>
											<Button
												icon="trash"
												stylingMode="text"
												onClick={() => {
													setViewPermissions((prev: any[]) =>
														prev.filter(
															p =>
																!(
																	p.folder === permission.folder &&
																	p.model === permission.model &&
																	p.permission === permission.permission
																)
														)
													)
													axios
														.delete(`${API_FIBER_URL}/users/${user_id}/view-permissions`, {
															data: {
																folder: permission.folder,
																model: permission.model,
																permission: permission.permission,
															},
														})
														.catch(error => {
															setViewPermissions((prev: any[]) => [...prev, permission])
														})
												}}
												style={{ color: '#f44336' }}
											/>
										</div>
									</div>
								</div>
							))}
						</div>
					)}

					{selectedView && (
						<div className="dx-fieldset">
							<div
								className="dx-fieldset-header"
								style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)', marginTop: '20px' }}
							>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<div>
										View Permissions for {selectedView}
										{selectedModelData && (
											<div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
												Default: Delete={defaultDeleting ? 'Enabled' : 'Disabled'} // Insert=
												{defaultInserting ? 'Enabled' : 'Disabled'} // Export=
												{defaultExporting ? 'Enabled' : 'Disabled'}
											</div>
										)}
									</div>
									{(explicitDeletePermission ||
										explicitInsertPermission ||
										explicitExportPermission) && (
										<Button
											text="Reset to Default"
											stylingMode="outlined"
											type="normal"
											onClick={() => {
												if (explicitDeletePermission) {
													changedViewPermission(
														user_id,
														selectedFolder,
														selectedModel,
														explicitDeletePermission.permission,
														{
															value: false,
															event: { stopPropagation: () => {} },
														}
													)
												}
												if (explicitInsertPermission) {
													changedViewPermission(
														user_id,
														selectedFolder,
														selectedModel,
														explicitInsertPermission.permission,
														{
															value: false,
															event: { stopPropagation: () => {} },
														}
													)
												}
												if (explicitExportPermission) {
													changedViewPermission(
														user_id,
														selectedFolder,
														selectedModel,
														explicitExportPermission.permission,
														{
															value: false,
															event: { stopPropagation: () => {} },
														}
													)
												}
											}}
										/>
									)}
								</div>
							</div>
							<div className="dx-field">
								<div
									className="dx-field-label"
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}
								>
									<span>Delete Permission</span>
								</div>
								<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
									<span style={{ fontSize: '12px' }}>Delete:</span>
									<Switch
										value={effectiveDeletePermission}
										onValueChanged={e => {
											if (e.value === defaultDeleting) {
												if (explicitDeletePermission) {
													changedViewPermission(
														user_id,
														selectedFolder,
														selectedModel,
														explicitDeletePermission.permission,
														{
															value: false,
															event: { stopPropagation: () => {} },
														}
													)
												}
											} else {
												const permissionType = e.value ? 'delete_allow' : 'delete_deny'
												if (explicitDeletePermission) {
													changedViewPermission(
														user_id,
														selectedFolder,
														selectedModel,
														explicitDeletePermission.permission,
														{
															value: false,
															event: { stopPropagation: () => {} },
														}
													)
												}
												changedViewPermission(
													user_id,
													selectedFolder,
													selectedModel,
													permissionType,
													{
														value: true,
														event: { stopPropagation: () => {} },
													}
												)
											}
										}}
									/>
									{explicitDeletePermission && (
										<span style={{ fontSize: '10px', color: '#4CAF50', marginLeft: '5px' }}>
											(Explicit)
										</span>
									)}
									{!explicitDeletePermission && (
										<span style={{ fontSize: '10px', color: '#666', marginLeft: '5px' }}>
											(Default)
										</span>
									)}
								</div>
							</div>
							<div className="dx-field">
								<div
									className="dx-field-label"
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}
								>
									<span>Insert Permission</span>
								</div>
								<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
									<span style={{ fontSize: '12px' }}>Insert:</span>
									<Switch
										value={effectiveInsertPermission}
										onValueChanged={e => {
											if (e.value === defaultInserting) {
												if (explicitInsertPermission) {
													changedViewPermission(
														user_id,
														selectedFolder,
														selectedModel,
														explicitInsertPermission.permission,
														{
															value: false,
															event: { stopPropagation: () => {} },
														}
													)
												}
											} else {
												const permissionType = e.value ? 'insert_allow' : 'insert_deny'
												if (explicitInsertPermission) {
													changedViewPermission(
														user_id,
														selectedFolder,
														selectedModel,
														explicitInsertPermission.permission,
														{
															value: false,
															event: { stopPropagation: () => {} },
														}
													)
												}
												changedViewPermission(
													user_id,
													selectedFolder,
													selectedModel,
													permissionType,
													{
														value: true,
														event: { stopPropagation: () => {} },
													}
												)
											}
										}}
									/>
									{explicitInsertPermission && (
										<span style={{ fontSize: '10px', color: '#4CAF50', marginLeft: '5px' }}>
											(Explicit)
										</span>
									)}
									{!explicitInsertPermission && (
										<span style={{ fontSize: '10px', color: '#666', marginLeft: '5px' }}>
											(Default)
										</span>
									)}
								</div>
							</div>
							<div className="dx-field">
								<div
									className="dx-field-label"
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}
								>
									<span>Export Permission</span>
								</div>
								<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
									<span style={{ fontSize: '12px' }}>Export:</span>
									<Switch
										value={effectiveExportPermission}
										onValueChanged={e => {
											if (e.value === defaultExporting) {
												if (explicitExportPermission) {
													changedViewPermission(
														user_id,
														selectedFolder,
														selectedModel,
														explicitExportPermission.permission,
														{
															value: false,
															event: { stopPropagation: () => {} },
														}
													)
												}
											} else {
												const permissionType = e.value ? 'export_allow' : 'export_deny'
												if (explicitExportPermission) {
													changedViewPermission(
														user_id,
														selectedFolder,
														selectedModel,
														explicitExportPermission.permission,
														{
															value: false,
															event: { stopPropagation: () => {} },
														}
													)
												}
												changedViewPermission(
													user_id,
													selectedFolder,
													selectedModel,
													permissionType,
													{
														value: true,
														event: { stopPropagation: () => {} },
													}
												)
											}
										}}
									/>
									{explicitExportPermission && (
										<span style={{ fontSize: '10px', color: '#4CAF50', marginLeft: '5px' }}>
											(Explicit)
										</span>
									)}
									{!explicitExportPermission && (
										<span style={{ fontSize: '10px', color: '#666', marginLeft: '5px' }}>
											(Default)
										</span>
									)}
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		)
	}

	function hasRoleView(views: [], folder: string, model: string) {
		const key = `${folder}/${model}` as never
		return views && (views.indexOf(key) > -1 || views.indexOf(model as never) > -1)
	}

	function setRoleView(views: [], folder: string, model: string) {
		let newViews = views
		if (newViews === null) {
			newViews = []
		}
		const key = `${folder}/${model}` as never
		if (newViews && newViews.indexOf(key) === -1) {
			newViews.push(key)
		}
		return newViews
	}

	function unsetRoleView(views: [], folder: string, model: string) {
		const key = `${folder}/${model}` as never
		let index = views ? views.indexOf(key) : -1
		if (index > -1) {
			delete views[index]
		}
		// backward compatibility
		index = views ? views.indexOf(model as never) : -1
		if (index > -1) {
			delete views[index]
		}
		return views
	}

	function hasRoleProcess(processes: [], process: string) {
		return processes && processes.indexOf(process as never) > -1
	}

	function setRoleProcess(processes: [], process: string) {
		let newProcess = processes
		if (newProcess === null) {
			newProcess = []
		}
		if (newProcess && newProcess.indexOf(process as never) === -1) {
			newProcess.push(process as never)
		}
		return newProcess
	}

	function unsetRoleProcess(processes: [], process: string) {
		const index = processes ? processes.indexOf(process as never) : -1
		if (index > -1) {
			delete processes[index]
		}
		return processes
	}

	function hasRoleReport(reports: [], report: string) {
		return reports && reports.indexOf(report as never) > -1
	}

	function setRoleReport(reports: [], report: string) {
		let newReport = reports
		if (newReport === null) {
			newReport = []
		}
		if (newReport && newReport.indexOf(report as never) === -1) {
			newReport.push(report as never)
		}
		return newReport
	}

	function unsetRoleReport(reports: [], report: string) {
		const index = reports ? reports.indexOf(report as never) : -1
		if (index > -1) {
			delete reports[index]
		}
		return reports
	}

	function Roles() {
		const g = group as any
		const { name, users } = g
		return (
			<div className="form">
				<div className="dx-fieldset">
					<div className="dx-fieldset-header" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
						Group: {name} - Views
					</div>
					{(Object.entries(views) as [string, any[]][]).flatMap(([category, viewList]) =>
						viewList.map((view: any) => {
							const hasViewRole = hasRoleView(g?.views as [], category, view.model)
							return (
								<div className="dx-field" key={category + '/' + view.model}>
									<div className="dx-field-label" style={{ whiteSpace: 'normal' }}>
										{category} / {view.text}
									</div>
									<Switch
										value={hasViewRole}
										onValueChanged={e => changedRoleView(category, view.model, e)}
									></Switch>
									{view.show_deny && hasViewRole && (
										<div
											style={{
												marginLeft: '20px',
												display: 'flex',
												alignItems: 'center',
											}}
										>
											<i
												className="dx-icon dx-icon-lock"
												style={{ fontSize: '20px', color: 'grey', marginRight: '2px' }}
											></i>
											<Switch
												value={hasRoleView(g?.deny_modify_views as [], category, view.model)}
												onValueChanged={e => changedRoleDenyModifyView(category, view.model, e)}
											></Switch>
										</div>
									)}
								</div>
							)
						})
					)}
				</div>
				<div className="dx-fieldset">
					<div className="dx-fieldset-header" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
						Group: {name} - Processes
					</div>
					{Object.entries(processes).map(([process, text]) => (
						<div className="dx-field" key={process}>
							<div className="dx-field-label">{text as string}</div>
							<Switch
								value={hasRoleProcess(g?.processes as [], process)}
								onValueChanged={e => changedRoleProcess(process, e)}
							></Switch>
						</div>
					))}
				</div>
				<div className="dx-fieldset">
					<div className="dx-fieldset-header" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
						Group: {name} - Reports
					</div>
					{Object.entries(reports).map(([report, text]) => (
						<div className="dx-field" key={report}>
							<div className="dx-field-label">{text as string}</div>
							<Switch
								value={hasRoleReport(g?.reports as [], report)}
								onValueChanged={e => changedRoleReport(report, e)}
							></Switch>
						</div>
					))}
				</div>
				<div className="dx-fieldset">
					<div className="dx-fieldset-header" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
						Group: {name} - Users
					</div>
					{users.map((user: any) => (
						<div className="dx-field" key={user.user_id}>
							<div className="dx-field-label">
								<Button
									icon="trash"
									stylingMode="text"
									onClick={() => {
										confirmDialog(
											'Remove user',
											`Are you sure you want to remove ${user.name} from group ${name}?`
										).then(result => {
											if (result) {
												removeUserFromGroup(user, g)
											}
										})
									}}
									hint="Remove user"
									style={{ marginRight: '5px', color: '#f44336' }}
								/>
								{user.name}
							</div>
						</div>
					))}
				</div>
			</div>
		)
	}

	function deselect() {
		usersGridRef.current?.instance.deselectAll()
		groupsGridRef.current?.instance.deselectAll()
		viewsGridRef.current?.instance.deselectAll()
		processesGridRef.current?.instance.deselectAll()
		reportsGridRef.current?.instance.deselectAll()
	}

	return (
		<React.Fragment>
			<h2 className={'content-block'}>Roles</h2>
			<TabPanel onTitleClick={() => deselect()}>
				<TabItem title="Users" icon="user">
					<Box direction="row" width="100%" height="100%">
						<BoxItem ratio={1}>
							<DataGrid
								ref={usersGridRef}
								height={height}
								className={'dx-card wide-card'}
								dataSource={userStore}
								remoteOperations={false}
								focusedRowEnabled={false}
								autoNavigateToFocusedRow={false}
								hoverStateEnabled={true}
								columnAutoWidth={true}
								showBorders={false}
								onSelectionChanged={selectUser}
							>
								<Paging enabled={false} />
								<Selection mode="single" />
								<FilterRow visible={true} />
								<Column dataField="name" caption="Username" allowSorting={false} />
								<Toolbar>
									<ToolbarItem location="after">
										<Button
											icon="refresh"
											onClick={() => {
												usersGridRef.current?.instance.refresh()
											}}
										/>
									</ToolbarItem>
								</Toolbar>
							</DataGrid>
						</BoxItem>
						<BoxItem ratio={2}>
							<div className="box-item orange">{Object.keys(user).length > 0 && <UserGroups />}</div>
						</BoxItem>
					</Box>
				</TabItem>
				<TabItem title="Groups" icon="group">
					<Box direction="row" width="100%" height="100%">
						<BoxItem ratio={1}>
							<DataGrid
								ref={groupsGridRef}
								height={height}
								className={'dx-card wide-card'}
								dataSource={groupStore}
								remoteOperations={false}
								focusedRowEnabled={false}
								autoNavigateToFocusedRow={false}
								hoverStateEnabled={true}
								columnAutoWidth={true}
								showBorders={false}
								onSelectionChanged={selectGroup}
							>
								<Editing
									startEditAction="dblClick"
									mode="cell"
									allowAdding
									allowUpdating
									allowDeleting
								/>
								<Paging enabled={false} />
								<Selection mode="single" />
								<Column
									dataField="name"
									dataType="string"
									caption="Group name"
									allowSorting={false}
								></Column>
								<Toolbar>
									<ToolbarItem location="before">
										<Button
											icon="add"
											onClick={() => {
												groupsGridRef.current?.instance.addRow()
											}}
										/>
									</ToolbarItem>
									<ToolbarItem location="after">
										<Button
											icon="refresh"
											onClick={() => {
												groupsGridRef.current?.instance.refresh()
											}}
										/>
									</ToolbarItem>
								</Toolbar>
							</DataGrid>
						</BoxItem>
						<BoxItem ratio={2}>
							<div className="box-item orange">{Object.keys(group).length > 0 && <Roles />}</div>
						</BoxItem>
					</Box>
				</TabItem>
				<TabItem title="Views" icon="folder">
					<Box direction="row" width="100%" height="100%">
						<BoxItem ratio={2}>
							<DataGrid
								ref={viewsGridRef}
								height={height}
								className={'dx-card wide-card'}
								dataSource={viewsStore}
								remoteOperations={false}
								focusedRowEnabled={false}
								autoNavigateToFocusedRow={false}
								hoverStateEnabled={true}
								columnAutoWidth={true}
								showBorders={false}
								onSelectionChanged={selectView}
							>
								<Paging enabled={false} />
								<Selection mode="single" />
								<FilterRow visible={true} />
								<Column dataField="name" caption="View name" dataType="string" allowSorting={false} />
							</DataGrid>
						</BoxItem>
						<BoxItem ratio={2}>
							<div className="box-item orange">{Object.keys(view).length > 0 && <ViewGroups />}</div>
						</BoxItem>
					</Box>
				</TabItem>
				<TabItem title="Processes" icon="upload">
					<Box direction="row" width="100%" height="100%">
						<BoxItem ratio={2}>
							<DataGrid
								ref={processesGridRef}
								height={height}
								className={'dx-card wide-card'}
								dataSource={processesStore}
								remoteOperations={false}
								focusedRowEnabled={false}
								autoNavigateToFocusedRow={false}
								hoverStateEnabled={true}
								columnAutoWidth={true}
								showBorders={false}
								onSelectionChanged={selectProcess}
							>
								<Paging enabled={false} />
								<Selection mode="single" />
								<Column dataField="name" caption="Process name" allowSorting={false} />
							</DataGrid>
						</BoxItem>
						<BoxItem ratio={2}>
							<div className="box-item orange">
								{Object.keys(process).length > 0 && <ProcessGroups />}
							</div>
						</BoxItem>
					</Box>
				</TabItem>
				<TabItem title="Reports" icon="chart">
					<Box direction="row" width="100%" height="100%">
						<BoxItem ratio={2}>
							<DataGrid
								ref={reportsGridRef}
								height={height}
								className={'dx-card wide-card'}
								dataSource={reportsStore}
								remoteOperations={false}
								focusedRowEnabled={false}
								autoNavigateToFocusedRow={false}
								hoverStateEnabled={true}
								columnAutoWidth={true}
								showBorders={false}
								onSelectionChanged={selectReport}
							>
								<Paging enabled={false} />
								<Selection mode="single" />
								<Column dataField="name" caption="Report name" allowSorting={false} />
							</DataGrid>
						</BoxItem>
						<BoxItem ratio={2}>
							<div className="box-item orange">{Object.keys(report).length > 0 && <ReportGroups />}</div>
						</BoxItem>
					</Box>
				</TabItem>
				<TabItem title="Field Permissions" icon="key">
					<Box direction="row" width="100%" height="100%">
						<BoxItem ratio={1}>
							<DataGrid
								ref={usersGridRef}
								height={height}
								className={'dx-card wide-card'}
								dataSource={userStore}
								remoteOperations={false}
								focusedRowEnabled={false}
								autoNavigateToFocusedRow={false}
								hoverStateEnabled={true}
								columnAutoWidth={true}
								showBorders={false}
								onSelectionChanged={selectUser}
							>
								<Paging enabled={false} />
								<Selection mode="single" />
								<FilterRow visible={true} />
								<Column dataField="name" caption="Username" allowSorting={false} />
								<Toolbar>
									<ToolbarItem location="after">
										<Button
											icon="refresh"
											onClick={() => {
												usersGridRef.current?.instance.refresh()
											}}
										/>
									</ToolbarItem>
								</Toolbar>
							</DataGrid>
						</BoxItem>
						<BoxItem ratio={2}>
							<div className="box-item orange">
								{Object.keys(user).length > 0 && <FieldPermissions />}
							</div>
						</BoxItem>
					</Box>
				</TabItem>
				<TabItem title="View Permissions" icon="lock">
					<Box direction="row" width="100%" height="100%">
						<BoxItem ratio={1}>
							<DataGrid
								ref={usersGridRef}
								height={height}
								className={'dx-card wide-card'}
								dataSource={userStore}
								remoteOperations={false}
								focusedRowEnabled={false}
								autoNavigateToFocusedRow={false}
								hoverStateEnabled={true}
								columnAutoWidth={true}
								showBorders={false}
								onSelectionChanged={selectUser}
							>
								<Paging enabled={false} />
								<Selection mode="single" />
								<FilterRow visible={true} />
								<Column dataField="name" caption="Username" allowSorting={false} />
								<Toolbar>
									<ToolbarItem location="after">
										<Button
											icon="refresh"
											onClick={() => {
												usersGridRef.current?.instance.refresh()
											}}
										/>
									</ToolbarItem>
								</Toolbar>
							</DataGrid>
						</BoxItem>
						<BoxItem ratio={2}>
							<div className="box-item orange">{Object.keys(user).length > 0 && <ViewPermissions />}</div>
						</BoxItem>
					</Box>
				</TabItem>
			</TabPanel>
		</React.Fragment>
	)
}
